import { Link } from 'react-router-dom';

const services = [
  {
    id: 1,
    icon: 'ri-settings-3-line',
    title: 'Sondermaschinen & Anlagenbau',
    subtitle: 'Individuelle Maschinen für Ihre Produktion',
    description:
      'Wir entwickeln und fertigen Sondermaschinen, die exakt auf Ihre Produktionsprozesse zugeschnitten sind. Von der ersten Skizze bis zur schlüsselfertigen Anlage begleiten wir Sie durch alle Projektphasen.',
    features: [
      'Konzeption und Konstruktion nach Kundenvorgaben',
      'Mechanische und elektrische Fertigung aus einer Hand',
      'Inbetriebnahme und Schulung vor Ort',
      'Langfristiger Service und Wartungsverträge',
      'Dokumentation nach Maschinenrichtlinie',
    ],
    image: '/images/ref1.jpg',
  },
  {
    id: 2,
    icon: 'ri-cpu-line',
    title: 'Steuerungstechnik, SPS & Automation',
    subtitle: 'Intelligente Steuerungen für komplexe Prozesse',
    description:
      'Unsere SPS-Spezialisten programmieren und integrieren Steuerungssysteme führender Hersteller. Wir sorgen für zuverlässige, wartungsfreundliche und zukunftssichere Automatisierungslösungen.',
    features: [
      'Siemens SIMATIC S7 / TIA Portal',
      'Beckhoff TwinCAT',
      'OMRON Sysmac / NJ / NX',
      'Visualisierung mit SCADA und HMI',
      'Fernwartung und Diagnose',
    ],
    image: '/images/schrank1.jpg',
  },
  {
    id: 3,
    icon: 'ri-robot-line',
    title: 'Roboter- & Handlingsysteme',
    subtitle: 'Effiziente Prozesse durch intelligente Automatisierung',
    description:
      'Wir planen und realisieren vollautomatische Handlingsysteme, integrieren Industrieroboter und optimieren Ihre Materialflüsse. Das Ergebnis: höhere Produktivität, weniger Fehler, mehr Effizienz.',
    features: [
      'Zertifizierter Systemintegrator für Industrieroboter',
      'Fördertechnik und Transportsysteme',
      'Pick-and-Place und Montageanlagen',
      'Palettier- und Verpackungsanlagen',
      'Sicherheitstechnik nach EN ISO 13849',
    ],
    image: '/images/anlage2.jpg',
  },
  {
    id: 4,
    icon: 'ri-eye-line',
    title: 'Industrielle Bildverarbeitung',
    subtitle: 'Qualitätssicherung durch maschinelles Sehen',
    description:
      'Industrielle Bildverarbeitungssysteme ermöglichen eine zuverlässige Qualitätskontrolle, Fehlererkennung und Prozessüberwachung in Echtzeit. Wir entwickeln maßgeschneiderte Vision-Systeme für Ihre Anforderungen.',
    features: [
      'Kamera- und Beleuchtungssysteme',
      'Bildverarbeitungssoftware (Cognex, Keyence)',
      'Inline-Qualitätskontrolle',
      'OCR, Barcode- und DataMatrix-Lesung',
      'Integration in bestehende Anlagen',
    ],
    image: '/images/panel.jpg',
  },
  {
    id: 5,
    icon: 'ri-tools-line',
    title: 'Mechanische Fertigung',
    subtitle: 'Präzision in Metall und Kunststoff',
    description:
      'CNC-Fräsen, Draht- und Senkerodieren sowie die Fertigung individueller Baugruppen und Vorrichtungen – alles aus einer Hand. Unsere Fertigungstiefe ermöglicht kurze Wege und höchste Qualität.',
    features: [
      'CNC-Fräsen und Drehen',
      'Draht- und Senkerodieren',
      'Baugruppen- und Vorrichtungsfertigung',
      'Qualitätsprüfung nach Zeichnung',
      'Klein- und Mittelserienfertigung',
    ],
    image: '/images/detail1.jpg',
  },
  {
    id: 6,
    icon: 'ri-code-s-slash-line',
    title: 'Hard- & Softwareentwicklung',
    subtitle: 'Kundenspezifische Lösungen aus einer Hand',
    description:
      'Wir entwickeln kundenspezifische Hard- und Softwarelösungen zur Anpassung von Maschinen, Prüfplätzen und Automatisierungssystemen – von der Schaltplanerstellung bis zur fertigen Applikation.',
    features: [
      'Schaltplanerstellung mit WSCAD',
      'Embedded-Systeme und Mikrocontroller',
      'PC-basierte Steuerungen und HMI',
      'Prüfstand- und Messsoftware',
      'Schnittstellenentwicklung (OPC-UA, Profinet)',
    ],
    image: '/images/sps1.jpg',
  },
  {
    id: 7,
    icon: 'ri-focus-3-line',
    title: 'Lasertechnik',
    subtitle: 'Präzise Laserbearbeitung für höchste Anforderungen',
    description:
      'Mit modernster Lasertechnologie bieten wir präzise Bearbeitungslösungen für Metall, Kunststoff und Verbundwerkstoffe. Ob Schneiden, Schweißen, Markieren oder Gravieren – unsere Laserlösungen erfüllen höchste Qualitätsansprüche.',
    features: [
      'Laserschneiden von Metall und Kunststoff',
      'Laserschweißen für Feinbaugruppen',
      'Lasermarkierung und -gravur (Seriennummern, Logos)',
      'Laserstrukturierung und Oberflächenbearbeitung',
      'Integration in automatisierte Fertigungslinien',
    ],
    image: 'https://readdy.ai/api/search-image?query=industrial%20laser%20technology%20precision%20laser%20cutting%20metal%20manufacturing%20facility%20with%20bright%20laser%20beam%20and%20sparks%20in%20a%20modern%20production%20environment&width=760&height=380&seq=lasertec-service-01&orientation=landscape',
  },
];

const ServiceCards = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col gap-20">
          {services.map((service, index) => (
            <div
              key={service.id}
              className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center"
            >
              {/* Image */}
              <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                <div className="relative">
                  <div className="w-full h-[320px] md:h-[380px] rounded-xl overflow-hidden bg-gray-100">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover object-top"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute -top-4 -left-4 w-12 h-12 flex items-center justify-center bg-[#1E3A8A] rounded-xl">
                    <span className="text-white font-bold text-lg">0{service.id}</span>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                <div className="w-12 h-12 flex items-center justify-center bg-[#EFF6FF] rounded-xl mb-5">
                  <i className={`${service.icon} text-[#1E3A8A] text-xl`}></i>
                </div>
                <span className="text-[#DC2626] text-xs font-semibold tracking-widest uppercase">{service.subtitle}</span>
                <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-2 mb-4">{service.title}</h2>
                <p className="text-gray-600 text-base leading-relaxed mb-6">{service.description}</p>

                <ul className="flex flex-col gap-2.5 mb-8">
                  {service.features.map((feature) => (
                    <li key={feature} className="flex items-start gap-3 text-gray-700 text-sm">
                      <span className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                        <i className="ri-check-line text-[#1E3A8A]"></i>
                      </span>
                      {feature}
                    </li>
                  ))}
                </ul>

                <Link
                  to="/anfrage"
                  className="inline-flex items-center gap-2 bg-[#1E3A8A] hover:bg-[#1e40af] text-white font-semibold px-6 py-3 rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
                >
                  Anfrage stellen
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceCards;
